import Hls from "hls.js"
import { forwardRef, useContext, useEffect, useImperativeHandle, useRef, useState } from "react"
import {  PlayerContainer, PlayerWrapper, Video, VideoContainer, Audio } from "./Components";
import { PreLoader } from "../PreLoader/PreLoader";
import { WebsiteContext } from "../../context/WebsiteContext";
import { AppContext } from "../../context/AppContext";
import { classNames } from "../../helper";
import { ButtonContainer } from "../BackgroundVideo/Components";
import { Play } from "./Play";
import { PlayerNavigator } from "../Navigator/PlayerNavigator";
import { PlayerToolbarContext } from "../../context/PlayerToolbarContext";

export const PMCRadioPlayer = forwardRef(({src, video, poster}, ref) => {
    let timeout;
    const videoRef = useRef(null);
    const playerRef = useRef(null);
    const abortController = useRef(null);
    const websiteContext = useContext(WebsiteContext);
    const playerToolbarContext = useContext(PlayerToolbarContext);
    const appContext = useContext(AppContext);
    const [isPlaying, setIsPlaying] = useState(false);
    const [isClicked, setIsClicked] = useState(false);
    const [isAutoPlay, setIsAutoPlay] = useState(true);
    const [isBuffering, setIsBuffering] = useState(true);
    useImperativeHandle(ref, () => {
        return {
            play: init,
            pause: handlePause,
            remove: handleStop,
            isPlaying: () => isPlaying,
            hasMultiQuality: () => false
        }
    })
    const canAutoPlay = () => {
        if(appContext.isCameFromHome){
            return true;
        }else{
            return isClicked
        }
    }
    useEffect(() => {
        init();
        return () => {
            handleStop();
            clearTimeout(timeout);
          };
    }, []);
    useEffect(() => {
        if(ref && ref.current)
            websiteContext.initVideoPlayer(ref.current);
    }, [ref]);
    useEffect(() => {
        websiteContext.setIsStreamPlaying(isPlaying);   
    }, [isPlaying]);
    const init = () => {
        playerRef.current.src = src;
        playerRef.current.muted = false;
        playerRef.current.volume = 1;
        handlePlay();
    }
    const handleStop = () => {
        setIsPlaying(false);
        const player = playerRef.current;
        if (player) {
            player.src = "";
            player.load();
            videoRef.current.pause();
            player.removeEventListener('pause', handlePause)
            player.pause();
        }
        
        if(abortController.current){
            abortController.current.abort();
        }
        
    }
    const handlePause = () => {
        handleStop();;
    }
    const handlePlay = (canPlay = false) => {
        if(isPlaying) return;
        setIsPlaying(false);
        setIsBuffering(true);
        if(canPlay || canAutoPlay()){
            playerRef.current.play().then(() => {
                abortController.current = new AbortController();
                setIsPlaying(true);
                setIsBuffering(false);
                playerRef.current.addEventListener('pause', handlePause)
            }).catch((err) => {
                if(err.name === "NotAllowedError"){
                    setIsBuffering(false);
                    setIsAutoPlay(false);
                }
                setIsPlaying(false);
                
            });
        }else{
            setIsBuffering(false);
            setIsAutoPlay(false);
        }
    }
    
    const onCanPlayThrough = (e) => {
        console.log("Audio Loaded")
        setIsBuffering(false);
    }
    const onErrorLoading = (e) => {
        console.log("Error in loading: "+ e);
    }
    return (
        <PlayerContainer onClick={playerToolbarContext.onClickShowOrHideMenu}>
            <PlayerWrapper>
                {(isBuffering) && <PreLoader show={true} disableBackground={true}/>}
                {!isAutoPlay && <ButtonContainer onClick={(e) => {
                    setIsAutoPlay(true);
                    setIsBuffering(true);
                    setIsClicked(true);
                    handlePlay(true);
                }} className={classNames([!appContext.isLandscape && "rotate"])}><Play /></ButtonContainer>}
                <VideoContainer>
                    <Video ref={videoRef} 
                        loop={true} 
                        muted={true}
                        src={video}
                        controls={false} 
                        autoPlay={isAutoPlay}
                        playsInline={true}
                        webkit-playsinline
                        className={classNames([!appContext.isLandscape && "rotate"])}>
                        <p>This browser doesn't support hls</p>
                    </Video>
                    
                </VideoContainer>
                <Audio autoPlay={isAutoPlay} playsInline={true} webkit-playsinline preload="auto" ref={playerRef} onCanPlayThrough={onCanPlayThrough} onPause={handlePause} onError={onErrorLoading}>
                    <source src={null} type="audio/mpeg" />
                </Audio>
                <PlayerNavigator />
            </PlayerWrapper>
        </PlayerContainer>
        
    )
})